import React from "react";
import { Link } from "react-router-dom";
import { Trans, withTranslation } from "react-i18next";
import { Callout, Button } from "@blueprintjs/core";

import Title from "./logo";

function NotFoundPage(props) {
  return <div>
    <Title icon="bug" text={<Trans>error</Trans>} />
    <Callout intent="danger" title={"404"}>
      <p><Trans>page not found</Trans></p>
      <Link to="/home" style={{ textDecoration: 'none', color: 'inherit' }}>
        <Button icon="home" text={<Trans>home</Trans>} />
      </Link>
    </Callout>
  </div>
}

export default withTranslation()(NotFoundPage)
